import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnassignSuccess = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4976 25.5021C68.062 43.8068 62.8206 57.6083 47.1726 65.8731C37.2226 71.1285 25.767 74.9868 19.8893 84.5823C-1.51919 119.532 44.1152 148.28 73.4972 114C98.4156 84.9275 136.624 152.34 172.997 97.5C205.496 48.5007 138.997 -23.0008 87.4976 25.5021Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88,
			cy: 120,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39,
			cy: 35,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76 25H115C121.075 25 126 29.9249 126 36V36C126 42.0751 121.075 47 115 47H60.75C54.8129 47 50 51.8129 50 57.75V57.75C50 63.6871 54.8129 68.5 60.75 68.5H139.5C145.575 68.5 150.5 73.4249 150.5 79.5V79.5C150.5 85.5751 145.575 90.5 139.5 90.5H87.75C81.2607 90.5 76 95.7607 76 102.25V102.25C76 108.739 81.2607 114 87.75 114H107",
			stroke: "url(#paint0_linear_5312_25610)",
			strokeWidth: 5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100,
			cy: 68,
			r: 29,
			fill: "url(#paint1_linear_5312_25610)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86 78.4C86 73.7608 89.7608 70 94.4 70H105.6C110.239 70 114 73.7608 114 78.4C114 81.4928 111.493 84 108.4 84H91.6C88.5072 84 86 81.4928 86 78.4Z",
			fill: "url(#paint2_linear_5312_25610)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100,
			cy: 59,
			r: 9,
			fill: "url(#paint3_linear_5312_25610)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 76,
			cy: 25,
			r: 6,
			fill: "url(#paint4_linear_5312_25610)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106,
			cy: 114,
			r: 6,
			fill: "url(#paint5_linear_5312_25610)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M143.333 67.9998C143.333 75.3636 137.364 81.3332 130 81.3332C122.636 81.3332 116.667 75.3636 116.667 67.9998C116.667 60.636 122.636 54.6665 130 54.6665C137.364 54.6665 143.333 60.636 143.333 67.9998Z",
			fill: "#42AF60",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M135.69 62.9424C136.09 63.3233 136.105 63.9562 135.724 64.3562L128.105 72.3562C127.917 72.5543 127.655 72.6665 127.381 72.6665C127.107 72.6665 126.846 72.5543 126.657 72.3562L123.609 69.1562C123.228 68.7562 123.244 68.1233 123.644 67.7424C124.044 67.3615 124.677 67.3769 125.058 67.7769L127.381 70.2165L134.276 62.9769C134.657 62.5769 135.29 62.5615 135.69 62.9424Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5312_25610",
				x1: 53.8326,
				y1: 29.5254,
				x2: 132.356,
				y2: 119.04,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5312_25610",
				x1: 73.2119,
				y1: 41.9492,
				x2: 124.822,
				y2: 94.0508,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_5312_25610",
				x1: 87.0678,
				y1: 70.7119,
				x2: 96.9775,
				y2: 90.7201,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_5312_25610",
				x1: 91.6864,
				y1: 50.9153,
				x2: 107.703,
				y2: 67.0847,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5312_25610",
				x1: 70.4576,
				y1: 19.6102,
				x2: 81.1356,
				y2: 30.3898,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_5312_25610",
				x1: 100.458,
				y1: 108.61,
				x2: 111.136,
				y2: 119.39,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgUnassignSuccess);
export { ForwardRef as ReactComponent };
